import { Pipe, PipeTransform } from '@angular/core';

import { filterResultGroupName } from '../../constants';
import { Employee } from '../../models';

function compareByName(a: Employee, b: Employee) {
    return a.name > b.name ? 1 : -1;
}

function compareByNumber(a: Employee, b: Employee) {
    return a.number - b.number > 0 ? 1 : -1;
}

@Pipe({
    name: 'employeeSortInGroup',
})
export class EmployeeSortInGroupPipe implements PipeTransform {
    transform(employees: Employee[], groupName: string): Employee[] {
        if (groupName === filterResultGroupName) return [...employees].sort(compareByNumber);
        return [...employees].sort(compareByName);
    }
}
